<template>
  <div>
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <div v-if="!isLoading">


  <div class="columns is-vcentered">
    <div class="column is-7">
  <section class="hero is-bold">
    <div class="hero-body">
      <div class="container">
        <h1 class="title is-family-monospace">
          {{product.name}}<small class="is-size-5 has-text-grey" v-if="product.name != product.vendor.name"><br />by {{product.vendor.name}}</small>
        </h1>
        <p class="subtitle is-family-code">
          <span class="has-text-weight-bold">{{product.meta_chunks_total_count | numeral('0a') }}+ feedbacks</span><br />
        </p>
    </div>
    </div>
  </section>
  </div>
    <div class="column is-5">
      <product-mini-chart :product="product" height="150" />
    </div>
</div>

      <b-tabs :expanded="false">
          <b-tab-item label="Trends" icon="chart-line">
            HEY
          </b-tab-item>
          <b-tab-item label="Related categories" icon="shape">
            <CategoryCard v-for="category in product.categories" :key="category.id" :category="category" />
          </b-tab-item>
          <b-tab-item label="Other" icon="" disabled></b-tab-item>
      </b-tabs>


</div>
</div>
</template>




<script>
import ProductMiniChart from "@/charts/ProductMiniChart"
import CategoryCard from "@/components/CategoryCard"


export default {
  name: 'Product',
  data() {
      return {
        product: null,
        isLoading: true,
      }
  },
  methods: {
      getProduct: function() {
          this.isLoading = true

          this.url = `${this.$root.api_base_url}products/${this.$route.params.id}/`


          this.$http.get(this.url)
              .then(({
                  data
              }) => {
              this.product = data
              })
              .catch((error) => {
                  this.data = []
                  this.$snackbar.open({
                      message: error,
                      type: "is-warning"
                  })
                  throw error
              })
              .finally(() => {
                  this.isLoading = false
              })
      },
  },
  mounted: function() {
      this.getProduct();
  },
  components: {
    ProductMiniChart,
    CategoryCard,
  }
}
</script>

<style scoped>

</style>

<style>

.tabs a {
  border: none;
}

</style>
